<template>
  <div class="cash_card_pos" :class="{ fullscreen: fullscreen }">
    <section class="row">
      <article class="w-50 mx-auto my-4">
        <template v-if="fullscreen">
          <div class="section-title">{{ "Merit Gift Cards" }}</div>
          <button class="btn-modal-close" @click="callClose()">&times;</button>
        </template>
        <b-form-input
          v-model="merit_card_number"
          placeholder="Gift Card Number"
          class="mb-3 whiteBC"
          type="text"
          name="merit_card_number"
          id="merit_card_number"
          ref="merit_card_number"
          tabindex="0"
        ></b-form-input>
        <VkeyboardFloat
          :ID="'merit_card_number'"
          :onClickFun="
            () => {
              showVKeyboard = !showVKeyboard;
            }
          "
        />
        <Vkeyboard
          :inputName="'merit_card_number'"
          :showOrHide="showVKeyboard"
          :initialValue="merit_card_number"
          @onChangeEvent="onChangeKeboardData('merit_card_number')"
          @onKeyEnter="onKeyPress"
          @changeKeyboardInput="merit_card_number = $event"
          @onClickClose="
            () => {
              showVKeyboard = false;
            }
          "
        />
        <div class="col-12 mx-auto text-center">
          <div class="btn-blue-lg w-50 px-1" @click="validateMeritGiftcard">
            Submit
          </div>
        </div>
      </article>
    </section>

    <!-- DEBIT MONEY -->
    <b-modal
      hide-footer
      centered
      no-close-on-backdrop
      no-close-on-esc
      id="payByMeritGCModal"
      ref="payByMeritGCModal"
      :title="$t('payByMeritGCModal')"
      @shown="doFocus()"
      @close="inputValue = ''"
    >
      <div class="pos-mobile-number">
         <div class="row">
            <div class="col-12 mx-auto">
              <input
                type="text"
                name="MeritGCDebitAmount"
                id="MeritGCDebitAmount"
                ref="MeritGCDebitAmount"
                v-model="inputValue"
                :disabled="true"
                :class="disablePay ? 'disablePayText' : ''"
                placeholder="Enter Amount"
                class="mobile-number"
                v-on:keyup.enter="onPayViaMeritCard()"
                v-on:keydown="
                  (e) => {
                    if (
                      !/[0-9]/.test(e.key) &&
                      e.keyCode !== 8 &&
                      e.keyCode !== 190
                    ) {
                      e.preventDefault();
                    }
                  }
                "
              />
            <div class="d-flex align-item-center justify-content-between fs-14 my-2 text-danger" v-if="lowBalance">
                <div>Low Balance:</div>
                <div>{{currFormat(balance_amount)}}</div>
            </div>
            <div class="d-flex align-item-center justify-content-between fs-14 my-2" v-else>
                <div>Available Balance:</div>
                <div>{{currFormat(balance_amount)}}</div>
            </div>
              <div class="row" v-if="false">
                <div
                  class="col-4 mb-2"
                  v-for="(value, index) in keypadValues"
                  :key="index"
                >
                  <button
                    v-if="index == keypadValues.length - 2"
                    class="number"
                    @click="sliceNumber"
                  >
                    {{ value.name }}
                  </button>
                  <button
                    v-else-if="value.name != ''"
                    @click="onClicknumber(index)"
                    class="number"
                  >
                    {{ value.name }}
                  </button>
                  <button
                    v-else
                    @click.prevent.stop="clearInput"
                    class="number"
                  >
                    C
                  </button>
                </div>
              </div>
            </div>
          </div>
      </div>
      <div class="d-flex justify-content-center mt-3">
        <b-button
          variant="default"
          class="btn-blue"
          :disabled="disablePay"
          :class="disablePay ? 'disablePay' : ''"
          @click="onPayViaMeritCard()"
          >{{ $t("payByMeritGCModal") }}</b-button
        >
        <b-button
          variant="default"
          class="btn-blue"
          @click="$bvModal.hide('payByMeritGCModal')"
          >Cancel</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import PosKeyPad from "@/components/Partials/PosKeypad.vue";
import MasterService from "@/services/MasterService";
import AddCustomerDetailsPopup from "@/components/Partials/AddCustomerDetailsPopup";
import { mapState, mapGetters, mapActions } from "vuex";
import Vkeyboard from "@/components/Partials/Vkeyboard.vue";
import VkeyboardFloat from "@/components/Partials/keyboardFloatingToggle.vue";

export default {
  components: {
    PosKeyPad,
    AddCustomerDetailsPopup,
    Vkeyboard,
    VkeyboardFloat,
  },
  props: {
    onClickHandler: { type: Function },
    onClickAddMoney: { type: Function },
    onPayByGiftCard: { type: Function },
    fullscreen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disablePay: false,
      lowBalance: false,
      cardDetails: {
        balance: 0,
        giftcard_number: "",
        giftcard_currency: "",
        expiry_date: "",
        card_id: "",
        original_value: "",
        remaining_value: "",
        user_first_name: "",
        user_last_name: "",
        user_email: "",
        user_phone: "",
        giftcard_image: "",
        mylist_card: "",
        },
        dummyVerfiyObj: {
            status: true,
            balance: 1000,
        },
      cardImage: null,
      balance_amount: 0,
      merit_card_number: "",
      showVKeyboard: false,
      currencyData: "",
      inputAmount: "",
      inputValue: "",
      keypadValues: [
        { name: "1" },
        { name: "2" },
        { name: "3" },
        { name: "4" },
        { name: "5" },
        { name: "6" },
        { name: "7" },
        { name: "8" },
        { name: "9" },
        { name: "" },
        { name: "0" },
        { name: "<-" },
        { name: "." },
      ],
    };
  },
  beforeMount() {
    this.getCurrencyCode();
  },
  mounted() {
    setTimeout(() => {
        this.$refs.merit_card_number.focus(); 
    }, 500);
  },
  computed: {
    ...mapGetters([
      "getOfferPrice",
      "selectedFnBItemsTotalPrice",
      "TotalAdditionalTaxes",
    ]),
    isOfferApplied() {
      return this.$store.getters.isOfferApplied;
    },
    isCashCardTransaction() {
      return this.$store.getters.isCashCardTransaction;
    },
    curr_code() {
      return this.currencyData ? this.currencyData.curr_code : "";
    },
    cashInput() {
      return this.$store.getters.CASH_INPUT;
    },
    toPay() {
      let total =
        parseFloat(this.$store.getters.TOTAL_AMOUNT) +
        parseFloat(this.selectedFnBItemsTotalPrice) +
        parseFloat(this.TotalAdditionalTaxes) -
        parseFloat(this.$store.getters.getOfferPrice) -
        parseFloat(this.$store.getters.getSwapTotalAmount) -
        parseFloat(this.$store.getters.getloyaltyAmount)
      return total;
    },
  },
  methods: {
     onPayViaMeritCard() {
      if (
        +parseFloat(this.inputValue).toFixed(this.MIN_FRACTION_DIGITS) >
        +parseFloat(this.toPay).toFixed(this.MIN_FRACTION_DIGITS)
      ) {
        console.log("this.inputValue", this.inputValue);
        console.log("this.toPay", this.toPay);
        this.$toasted.show("Amount cannot be greater than ticket price!");
      } else if (!this.inputValue) {
        this.$toasted.show("Please Enter Amount");
      } else if (isNaN(this.inputValue)) {
        this.$toasted.show("Please Enter Valid Amount");
      } else {
        if (this.merit_card_number) {
          let payload = {
            card_number: this.merit_card_number,
            amount: this.inputValue,
            available_balance: this.balance_amount,
            remaining_balance: parseFloat((+parseFloat(this.balance_amount || 0).toFixed(this.MIN_FRACTION_DIGITS)) - (+parseFloat(this.inputValue || 0).toFixed(this.MIN_FRACTION_DIGITS))),
            reason: 'Deduction from POS',
            isApplied: 'Y'
          };
          this.setMeritCardData(payload);
          this.$bvModal.hide("payByMeritGCModal");
          this.onPayByGiftCard();
        } else {
          console.log("Something Went Wrong, Please try again");
        }
      }
    },
    validateMeritGiftcard() {
      if (!this.merit_card_number) {
        this.$toasted.show("Please Enter Gift Card Number");
      } else {
        let loader = this.$loading.show();
        let payload = {
          card_number: this.merit_card_number,
        };
        MasterService.VerifyMeritGirftCard(payload)
          .then((response) => {
            const { data } = response;
            // let data = this.dummyVerfiyObj
            if (data && data.status) {
              this.onResetOffersAndPrice();
              this.balance_amount = +parseFloat(data.balance).toFixed(this.MIN_FRACTION_DIGITS)
              if(data.hasOwnProperty('cardDetails')) {
                Object.keys(this.cardDetails).map((key) => {
                  this.cardDetails[key] = data.cardDetails[key]
                })
              }
              this.setInputAmount(this.balance_amount)
              console.log("data", data);
            } else {
              this.$toasted.show(data.message)
              console.log("data", data);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            loader.hide();
          });
      }
    },
    onKeyPress(button) {
      console.log('button', button);
    },
    onChangeKeboardData(refs) {
      if (refs) {
        this.$refs[refs].focus();
        this.$forceUpdate();
      }
    },
    sliceNumber() {
      this.doFocus();
      this.inputValue = this.inputValue.slice(0, -1);
    },
    onClicknumber(index) {
      this.doFocus();
      this.inputValue += this.keypadValues[index].name;
    },
    clearInput() {
      this.doFocus();
      this.inputValue = "";
    },
     doFocus() {
      this.$refs.MeritGCDebitAmount.focus();
    },
    getCurrencyCode: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
            this.$store.dispatch("SAVE_CURRENCY", this.currencyData.curr_code);
            this.$store.commit("GLOBAL_CURR_ID", this.currencyData.curr_id);
          } else {
            // Show Error Message:
          }
        })
        .catch((error) => {
          // Catch Error:
          console.log("Catch Error on getActiveScreenByCinemaId :", error);
        });
    },
    setInputAmount(balance) {
      let ticket_price = parseFloat(this.toPay).toFixed(this.MIN_FRACTION_DIGITS);
      let balance_amount = balance;
      if(balance == 0) {
        this.disablePay = true;
        this.lowBalance = true;
        this.$toasted.show('No Balance')
      } else {
         if (balance_amount >= ticket_price) {
            this.inputValue = ticket_price;
            this.disablePay = false;
            this.lowBalance = false;
        } else {
          this.inputValue = ticket_price;
          this.disablePay = true;
          this.lowBalance = true;
          this.$toasted.show('Low Balance')
          // this.inputValue = balance_amount;
        }
        this.$bvModal.show("payByMeritGCModal");
      }
    },
    hideCashCardPos() {
      this.cashCardPos = false;
      this.$emit("hideCashCardPos");
    },
    callClose: function () {
      this.$store.dispatch("resetCashCardData");
      this.onClickHandler("cashCard");
    },
    ...mapActions([
      "setStreetSale",
      "resetCustomerDetails",
      "setCashCardCustomerID",
      "setAddCashCardBalance",
      "SET_CASH_CARD_BALANCE",
      "setTopUpCashCard",
      "setNewCardSale",
      "setCashCardCustomer",
      "setUserDeatils",
      "selectCashCard",
      "setCashCardDebitAmount",
      "setMeritCardData",
      "onResetOffersAndPrice",
    ]),
  },
};
</script>

<style>
.whiteBC {
    background-color: #fff !important;
    border: 1px solid #80bdff !important;
}
.cash_card_pos {
  position: relative;
}

.cash_card_pos.fullscreen {
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 999;
  height: 100%;
  padding: 16px;
  position: fixed;
  background-color: #fff;
  overflow-y: auto;
}

.cash_card_pos .section-title {
  margin-bottom: 24px;
}

.cash_card_pos .btn-modal-close {
  position: absolute;
  top: -11px !important;
}

.disablePay {
  opacity: 0.5;
  pointer-events: none;
}

.disablePayText {
  color: red;
}

</style>



// WEBPACK FOOTER //
// src/components/Partials/MeritGiftCardSection.vue